import * as React from "react";
import "../../style/fonts.css";
import "./checkboxProgress.css";
import checked from "../../icons/checkbox_checked.svg";
import unchecked from "../../icons/checkbox_unchecked.svg";
export interface Props {
  isChecked: boolean;
}

class CheckboxProgress extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  render() {
    let src = unchecked;
    if (this.props.isChecked) {
      src = checked;
    }
    return (
      <div className="CHECKBOX_PRG_CHECKED">
        <img src={src} />
      </div>
    );
  }
}

export default CheckboxProgress;



// WEBPACK FOOTER //
// ./src/components/checkbox_progress/checkboxProgress.tsx